import { Application } from '@hotwired/stimulus'
import BootstrapController from './bootstrap_controller'
import GoogleMapsController from './google_maps_controller'
import HeroVideoController from './hero_video_controller'
import HtmlBoxesTheSameHeightController from './html_boxes_the_same_height_controller'
import HubspotFormController from './hubspot_form_controller'
import MarketingAnimationsController from './marketing_animations_controller'
import MarketingNavbarController from './marketing_navbar_controller'
import ScrollSnapController from './scroll_snap_controller'
import VideoController from './video_controller'
import YoutubePlayerController from './youtube_player_controller'

// Marketing-only registry. GSAP and the other controllers here are never
// instantiated by app or login pages, so they stay out of those bundles.
const application = Application.start()

window.Stimulus = application

application.debug = false
application.register('bootstrap', BootstrapController)
application.register('google-maps', GoogleMapsController)
application.register('hero-video', HeroVideoController)
application.register('html-boxes-the-same-height', HtmlBoxesTheSameHeightController)
application.register('hubspot-form', HubspotFormController)
application.register('marketing-animations', MarketingAnimationsController)
application.register('marketing-navbar', MarketingNavbarController)
application.register('scroll-snap', ScrollSnapController)
application.register('video', VideoController)
application.register('youtube-player', YoutubePlayerController)
